function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 5",
  cx: 0.965,
  cy: 0.965,
  r: 0.965,
  transform: "translate(4.245 18.584)",
  fill: "#17457a"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 65",
  d: "M5.209 18.583a.965.965 0 10.687.286.965.965 0 00-.687-.286z",
  fill: "#17457a"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 66",
  d: "M4.488 24.754a4.481 4.481 0 01-2.916-7.89l7.283-6.218A8.256 8.256 0 0119.789.576l1.284.519-5.484 5.479 2.594 2.594 5.482-5.484.519 1.284a8.187 8.187 0 01-1.844 8.864 8.187 8.187 0 01-8.231 2.07L7.89 23.187a4.5 4.5 0 01-3.225 1.565zm12.271-22.94a6.445 6.445 0 00-5.978 8.772l.246.613-8.256 7.063a2.645 2.645 0 00-.292 3.728c.044.051.092.1.139.15a2.753 2.753 0 001.976.776 2.622 2.622 0 001.906-.917l7.06-8.257.611.248a6.357 6.357 0 006.864-1.455 6.4 6.4 0 001.835-5.462l-4.688 4.7-5.188-5.199 4.69-4.69a6.238 6.238 0 00-.925-.07zm4.934 11.38",
  fill: "#17457a"
});

function SvgSpanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 163",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.773 24.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanner);
export default __webpack_public_path__ + "static/media/spanner.6731bc50.svg";
export { ForwardRef as ReactComponent };